import { useRef, useEffect } from 'react'
import { useCurrentUser } from '@wellesley/user/hooks/useCurrentUser'

type HookProps = {
  onChange: () => void
}

const useUserChange = ({ onChange }: HookProps) => {
  const { user } = useCurrentUser()
  const currentUserId = user?.id
  const prevUserId = useRef(currentUserId)

  useEffect(() => {
    if (!prevUserId.current) {
      prevUserId.current = currentUserId
      return
    }

    if (currentUserId !== prevUserId.current) {
      onChange()
      prevUserId.current = currentUserId
    }
  }, [currentUserId, prevUserId.current])
}

export default useUserChange
